document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-filter-cards]').forEach((group) => {
    const scrollerId = group.getAttribute('data-filter-cards');
    const scroller = document.querySelector(
      `[data-cards-scroller="${scrollerId}"]`
    );

    if (!scroller) return;

    const cards = scroller.querySelectorAll('[data-card]');
    const buttons = group.querySelectorAll('[data-filter]');
    const cardsEl = scroller.querySelector('.cards');

    const applyFilter = (schoolId) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const match =
          !schoolId || card.getAttribute('data-school') === schoolId;
        card.hidden = !match;
        if (match) visibleCount += 1;
      });

      if (cardsEl) {
        cardsEl.style.setProperty('--card-count', visibleCount);
      }

      buttons.forEach((btn) => {
        const isActive = (btn.getAttribute('data-filter') || '') === schoolId;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('btn--outline', !isActive);
      });

      scroller.scrollTo({ left: 0 });
      requestAnimationFrame(() => {
        scroller.dispatchEvent(new CustomEvent('cardscroller:refresh'));
      });
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        applyFilter(btn.getAttribute('data-filter') || '');
      });
    });
  });
});
